module.exports = __webpack_public_path__ + "img/logo_mixart.f6742cc3.svg";